import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { X, Sparkles, PlayCircle } from 'lucide-react';
import { startProductTour } from './ProductTour';

const WelcomeBanner = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const wasDismissed = localStorage.getItem('vibesprint_welcome_dismissed');
    if (!wasDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('vibesprint_welcome_dismissed', 'true');
    setIsVisible(false);
  };

  const handleImport = () => {
    handleDismiss();
    navigate('/import');
  };

  const handleStartTour = () => {
    startProductTour();
  };

  if (!isVisible) return null;

  return (
    <div
      className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent border-b border-primary/20"
      data-testid="welcome-banner"
    >
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="rounded-full bg-primary/10 p-2 flex-shrink-0">
              <Sparkles className="h-4 w-4 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">
                <span className="font-semibold">Welcome to VibeSprint!</span>{' '}
                <span className="text-muted-foreground">Take the 60-second tour to see how it works.</span>
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 flex-wrap">
            <Button
              size="sm"
              variant="outline"
              onClick={handleStartTour}
              data-testid="welcome-banner-tour-button"
            >
              <PlayCircle className="h-4 w-4 mr-1.5" />
              Start tour
            </Button>
            <Button
              size="sm"
              onClick={handleImport}
              className="btn-cta"
              data-testid="welcome-banner-import-button"
            >
              Add signals
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleDismiss}
              className="h-8 w-8 p-0"
              data-testid="welcome-banner-dismiss-button"
              aria-label="Dismiss welcome banner"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
